export default __webpack_public_path__ + "images/CheeseOmelette-375.jpg";